<template>
    <div class="choose-diagram layout-sub-page">
        <!-- 1. 顶部title -->
        <title-bar
            v-bind:titleData="titleData"
            v-bind:backFunc="hideChooseDiagram"
            v-bind:createFunc="clickChooseDiagramAll">
        </title-bar>
        <!-- 2. 主要部分:八宫六十四卦 -->
        <div class="choose-diagram-content">
            <div class="choose-diagram-list clearfix">
                <div class="choose-diagram-item-box" v-for="dData in diagramAll" :key="dData.value">
                    <div class="choose-diagram-item">
                        <div class="choose-diagram-i-title">{{dData.gong}}</div>
                        <div class="choose-diagram-i-list clearfix">
                            <div class="choose-diagram-i-item" v-for="gData in dData.gua" :key="gData.value"><div class="text" :class="{'selected': [dData.value, gData.value].join('') == (chooseDiagramType == 'first' ? firstDiagramValue : secondDiagramValue)}" @click="clickDiagramItem(dData.value, gData)">{{gData.text}}</div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import { CONST_DIAGRAM_ALL } from '../../modules/data/base/consts';
export default {
    name: 'ChooseDiagram',
    components: { TitleBar },
    computed: {
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        chooseDiagramType() {
            return this.$store.state.diagram.chooseDiagramType;
        },
        firstDiagramValue() {
            return this.$store.state.diagram.firstDiagramValue;
        },
        secondDiagramValue() {
            return this.$store.state.diagram.secondDiagramValue;
        }
    },
    data() {
        return {
            titleData: {
                'titleText': '主卦选择',
                'allButton': true, 
                'allButtonCName': ''
            },
            diagramAll: CONST_DIAGRAM_ALL,
            type: '',
        }
    },
    mounted() {
        setTimeout(() => {
            let type = this.chooseDiagramType;
            if(type == '') {
                let curPath = this.$router.history.current.path,
                    pathArr = curPath.split('/').filter(text => {return text != '' && text != 'embedded'});
                
                let fullPath = this.$router.history.current.fullPath;
                let replaceText = '/'+pathArr.slice(1).join('/');
                    fullPath = fullPath.replace(replaceText, '');
                // console.log('curPath-----', curPath, pathArr, replaceText)
                this.$router.replace(fullPath);
            }else {
                this.initChooseDiagram();
            }
        }, 20);
    },
    methods: {
        initChooseDiagram() {
            let type = this.chooseDiagramType;
            let title = type == 'first' ? '主卦选择' : '变卦选择';
            let firstDiagramFiltered = this.$store.state.diagram.firstDiagramFiltered;
            let secondDiagramFiltered = this.$store.state.diagram.secondDiagramFiltered;

            let className = type == 'first' ? (firstDiagramFiltered ? '' : 'green') : (secondDiagramFiltered ? '' : 'green');
            this.$set(this.titleData, 'titleText', title);
            this.$set(this.titleData, 'allButtonCName', className);

            console.log('initChooseDiagram------', type, title, firstDiagramFiltered, secondDiagramFiltered)
        },
        hideChooseDiagram(fromItem = false) {
            let curPath = this.$router.history.current.path;
            let fromPage = curPath.split('/')[1];
            console.log('fromPage-----', fromPage)
            if(fromPage == 'embedded') {
                this.hideEmbeddedChooseDiagram(fromItem);
                return;
            }
            switch(fromPage) {
                case 'diagram':
                    this.$router.replace('/diagram');
                    break;
                case 'diagramrecord':
                    this.$router.replace('/diagramrecord');
                    break;
                case 'diagramedit':
                    if(fromItem) {
                        this.$store.state.diagram.diagramTypeDataChanged = true;
                    }
                    this.$router.replace('/diagramedit/'+this.diagramData.id);
                    break;
                default:
                    break;
            }
        },
        hideEmbeddedChooseDiagram(fromItem = false) {
            let curPath = this.$router.history.current.path,
                pathArr = curPath.split('/').filter(text => {return text != '' && text != 'embedded'});
                
            let fullPath = this.$router.history.current.fullPath;
            let replaceText = '/'+pathArr.slice(1).join('/');
                fullPath = fullPath.replace(replaceText, '');
            if(pathArr[1] == 'diagramedit' && fromItem) {
                this.$store.state.diagram.diagramTypeDataChanged = true;
            }
            // console.log('curPath-----', curPath, pathArr, replaceText, fullPath)
            this.$router.replace(fullPath);
        },
        clickDiagramItem(dValue, gData) {
            // console.log('clickDiagramItem----', dValue, gData)
            let type = this.chooseDiagramType;
            switch(type) {
                case 'first':
                    this.$store.state.diagram.firstDiagramData = gData;
                    this.$store.state.diagram.firstDiagramValue = [dValue, gData.value].join('');
                    break;
                case 'second':
                    this.$store.state.diagram.secondDiagramData = gData;
                    this.$store.state.diagram.secondDiagramValue = [dValue, gData.value].join('');
                    break;
                default:
                    break;
            }
            this.$store.dispatch('diagram/filterRecordByDiagram', {
                type: type, all: false
            });
            this.hideChooseDiagram(true);
        },
        clickChooseDiagramAll() {
            let type = this.chooseDiagramType;
            switch(type) {
                case 'first':
                    this.$store.state.diagram.firstDiagramData = null;
                    this.$store.state.diagram.firstDiagramValue = '';
                    break;
                case 'second':
                    this.$store.state.diagram.secondDiagramData = null;
                    this.$store.state.diagram.secondDiagramValue = '';
                    break;
                default:
                    break;
            }
            this.$store.dispatch('diagram/filterRecordByDiagram', {
                type: type, all: true
            });
            this.hideChooseDiagram();
        }
    }
}
</script>